import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Warning } from "@phosphor-icons/react";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            {destructive && <Warning size={18} weight="fill" className="text-red-500" />}
            {title}
          </DialogTitle>
          <DialogDescription className="sr-only">{message}</DialogDescription>
        </DialogHeader>
        <p
          data-testid="confirm-dialog-message"
          className="text-sm text-gray-700 leading-relaxed bg-yellow-50 border border-yellow-200 rounded-md p-3 whitespace-pre-line"
        >
          {message}
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="confirm-dialog-cancel">
            {cancelLabel}
          </Button>
          <Button
            onClick={() => {
              onConfirm?.();
            }}
            data-testid="confirm-dialog-confirm"
            className={
              destructive
                ? "bg-red-600 hover:bg-red-700 text-white"
                : "bg-[#1A3A21] hover:bg-[#142C19] text-white"
            }
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
